import useMinerSettingsPoolControl, { ISelectOption } from "./MinerSettingsPool.control";
import { IMinerInfoSetting } from "@services/getMinerInfo";
import styles from "./MinerSettingsPool.module.scss";
import { useIntl } from "react-intl";
import { Flex, Select, Tooltip } from "antd";
import Status, { SettingPoolsStatus } from "@components/global/new/Status/Status";
import { IPoolCreds } from "@services/getSettings";
import Pools from "@components/global/new/PoolSelector/Pools/Pools";
import Algorithm from "@components/global/new/Algorithm/Algorithm";
import cn from "classnames";
import block from "@assets/icons/disable.svg";
import Icon from "@components/global/new/Icon/Icon";

export interface MinerSettingsPoolProps {
  readonly settingId?: number;
  readonly settings: IMinerInfoSetting[];
  readonly isAdminMiningOn: boolean;
  //readonly onChange: (id: number) => void;
}

interface MinerSettingsPoolLabelProps {
  pools?: IPoolCreds[];
}

function MinerSettingsPoolLabel({
  pools
}: MinerSettingsPoolLabelProps) {

  const { formatMessage } = useIntl();

  return (
    <Flex align="center" justify="space-between">
      <span className={styles.label}>
        {formatMessage({ id: "machines.settings.pool_name" })}
      </span>
      {pools && pools.length > 0 && pools[0].status !== undefined && (
        <Tooltip
          trigger={"click"}
          placement="right"
          color="#fff"
          title={<Pools pools={pools} />}
          destroyOnHidden
        >
          <div>
            <SettingPoolsStatus pools={pools} />
          </div>
        </Tooltip>
      )}
    </Flex>
  );
}

function MinerSettingsPool(props: MinerSettingsPoolProps) {

  const { formatMessage } = useIntl();
  const control = useMinerSettingsPoolControl(props);

  return (
    <div className={cn(styles.minerSettingsPool, {
      [styles.admin_mining]: control.isBlocked,
    })}>
      <label className={styles.select}>
        <MinerSettingsPoolLabel pools={control.value?.pools} />
        <Select
          options={control.options}
          value={control.value?.value}
          size="small"
          optionFilterProp="label"
          showSearch={true}
          filterOption={(input, option) => {
            return (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              || (option?.name ?? '').toLowerCase().includes(input.toLowerCase());
          }}

          labelRender={(option) => {
            const item = control.getOptionById(option.value as number);

            if (item) {
              return (
                <Algorithm
                  iconSize={16}
                  algo={item.algo}
                  className={cn(styles.selector, styles.item, styles.algo)}
                  hashName={item.name}
                  login={item.login}
                  normalizeCase
                />
              );

            } else {
              return (
                <span>
                  {option.label || formatMessage({ id: "change_setting.user_pools" })}
                </span>
              );
            }
          }}
          optionRender={(option) => {
            if (option.data.value !== -1) {
              return (
                <Algorithm
                  iconSize={16}
                  algo={option.data.algo}
                  className={cn(styles.selector, styles.item, styles.algo)}
                  hashName={option.data.name}
                  login={option.data.login}
                  normalizeCase
                />
              );
            } else {
              return (
                <span>
                  {option.label || formatMessage({ id: "change_setting.user_pools" })}
                </span>
              );
            }
          }}
          onChange={control.onChange}
        />
      </label>

      {control.isBlocked && (
        <div className={styles.adminMiningIsOn}>
          <span>{formatMessage({ id: "change_setting.admin_mining_is_on" })}</span>
          <Icon
            src={block}
            className={styles.disable_icon}
            title={"Blocked"}
            noHover
          />
        </div>
      )}
    </div>
  );
}

export default MinerSettingsPool;